define('partner/brandlock',[
    'jquery',
    'underscore',
    'baseview',
    'utils',
    'admanager',
    'adPosition',
    'adLogger'
],
function(
    $,
    _,
    BaseView,
    Utils,
    AdManager,
    AdPosition,
    AdLogger
) {
    'use strict';
    var Brandlock = BaseView.extend({

        initialize: function(options) {
            _.bindAll(this, 'onAdReady');
            this.$body = Utils.get('body');

            options = $.extend({
                el: this.$el,
                adType : 'Brandlock',
                adSizes : [300, 50],
                adPlacement : 'sponsor_logo',
                slotType: 'tagless',
                onAdReady: this.onAdReady,
                backgroundEl: this.$body
            }, options);

            BaseView.prototype.initialize.call(this, options);

            this.subviews.ad = new AdPosition(options);
        },

        destroy: function(removeEl) {
            this.options.backgroundEl.css('background', false);
            this.$body.removeClass('high-impact-ad-visible brandlock-visible');
            BaseView.prototype.destroy.call(this, false);
        },

        onAdReady: function(response) {
            var config;
            var jsonStr = response.slice((response.indexOf('N-->') + 4), response.indexOf('<!--/J'));

            var impStr = response.slice((response.indexOf('NS-->') + 5), response.indexOf('<!--/I'));
            impStr += response.slice(response.indexOf('ITD-->') + 6, response.indexOf('<!--/ITD'));

            try {
                config = JSON.parse(jsonStr);
            } catch(e) {
                AdLogger.logDebug('Brandlock is not valid JSON');
            }

            if(!config) return;

            var labelStyle = (config.labelcolor) ? ' style="color:' + config.labelcolor + '"' : '';

            // Setup sponsor image
            this.$el.html('<a href="' + config.click + '" class="gnt_x__bl_l" rel="nofollow" target="_blank" title="' + config.title + '"><span class="gnt_x__bl_lb"' + labelStyle + '>' + config.label + '</span><img src="' + config.logo + '" alt="' + config.name + '" class="gnt_x__bl_i"/></a>');
            document.documentElement.classList.add('gnt__bl');

            // Change background color
            this.$body.addClass('high-impact-ad-visible brandlock-visible');
            this.options.backgroundEl.css('background', '#ffffff');

            // Fire off impression img/script tags
            var tracking = document.createElement('div');
            tracking.classList.add('gnt_x__bl_h');
            tracking.innerHTML = impStr;
            this.subviews.ad.loadTrackingScripts(tracking);

            // Set additional targeting if available
            if(config.adlabel) {
                var overrides = AdManager.getOverrides();
                overrides.adlabel.push(config.adlabel);
                window.googletag.cmd.push(function() {
                    window.googletag.pubads().setTargeting('adlabel', overrides.adlabel);
                });
            }
        }
    });
    return Brandlock;
});

